import { AUTH } from './api'
import { METHOD, request } from '@/utils/request'

/**
 * 更新角色对应组织机构
 * @param {*} data 
 * @returns 
 */
export function addRoleOrganization(data) {
    return request(AUTH + '/organization/addRoleOrganization', METHOD.POST, data)
}

/**
 * 更新角色对应菜单
 * @param {*} data 
 * @returns 
 */
export function addRoleMenu(data) {
    return request(AUTH + "/menu/addRoleMenu", METHOD.POST, data)
}

/**
 * 更新角色对应事项
 * @param {*} data 
 * @returns 
 */
export function addRoleItem(data) {
    return request(AUTH + "/item/addRoleItem", METHOD.POST, data)
}

/**
 * 添加角色对应用户
 * @param {*} data 
 * @returns 
 */
export function addUserRole(data) {
    return request(AUTH + "/user/addUserRole", METHOD.POST, data)
}

/**
 * 删除角色对应用户
 * @param {*} data 
 * @returns 
 */
export function removeUserRole(data) {
    return request(AUTH + "/user/removeUserRole", METHOD.DELETE, data)
}

/**
 * 更新角色对应字典
 * @param {*} data 
 * @returns 
 */
export function addRoleDic(data) {
    return request(AUTH + "/dictionary/addRoleDic", METHOD.POST, data)
}

/**
 * 根据角色id查询学院数据
 * @param {*} data 
 * @returns 
 */
export function getRoleOrgInfo(data) {
    return request(AUTH + "/organization/getRoleOrgInfo", METHOD.GET, data)
}

/**
 * 根据角色id查询事项数据
 * @param {*} data 
 * @returns 
 */
export function getRoleItemInfo(data) {
    return request(AUTH + "/item/getRoleItemInfo", METHOD.GET, data)
}

/**
 * 获取当前用户操作权限
 * @param {*} data 
 * @returns 
 */
export function getCurrentUserOperate() {
    return request(AUTH + "/operate/getUserOperate", METHOD.GET)
}

/**
 * 获取当前用事项权限
 * @returns 
 */
export function getCurrentUserItems() {
    return request(AUTH + "/item/getUserItems", METHOD.GET)
}